module.exports = __webpack_public_path__ + "static/silos-599845919e531ec2e0ccb29ef31f1a48.jpg";